//
//
//
//
//
//
//
//
//
//
//

import AppGrid from "./Grid.vue";
import SearchHeader from "./SearchHeader.vue";

export default {
	name: "GridContainer",
	components: {
		AppGrid,
		SearchHeader,
	},
	props: {
		contacts: Array,
		user: String,
		district: String,
	},
	data() {
		return {};
	},
	computed: {
		greeting() {
			const timeOfDay = new Date().getHours();
			let colloquialism;
			switch (true) {
				case timeOfDay >= 19:
					colloquialism = 'evening';
					break;
				case timeOfDay >= 11:
					colloquialism = 'afternoon';
					break;
				case timeOfDay >= 4:
					colloquialism = 'morning';
					break;
				default:
					colloquialism = 'evening';
					break;
			}
			return `Good ${colloquialism}, <span>${this.user}!</span>`;
		},
	},
	methods: {},
	created() {},
};
